export default __webpack_public_path__ + "static/media/image-12.5fb86c76.png";